import React__default from 'react';
import classNames from 'classnames';
import Styles from './LazyFadeIn.module.scss.js';

// import { FadeIn } from "react-lazyload-fadein";
const { FadeIn } = require("react-lazyload-fadein");
const LazyFadeIn = ({ children, height, className }) => {
    return (React__default.createElement("div", { className: classNames(Styles.main, className) },
        React__default.createElement(FadeIn, { height: height }, (onLoad) => children(onLoad))));
};

export { LazyFadeIn as default };
//# sourceMappingURL=LazyFadeIn.js.map
